export default {
  from: 'desde',
  select: 'Ver vuelo',
  deal: 'offerta',
  deals: 'offertas',
  total: 'en total',
  total_fr: '',
  pp: 'pp',
}
